import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import ReactPlayer from "react-player";
import axios from "axios";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Table from "../Common/Table";
import img1 from "../../images/icon/img1.jpg";
import SimilarProjects from "./../Elements/SimilarProjects";
import productSeo from "../../seo/productSeo";
import { Helmet } from "react-helmet";

import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";

const withRouter = (Component) => {
  return (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
      />
    );
  };
};

class ProjectDetail extends React.Component {
  state = {
    productDetails: {},
    data2: {},
    features: [],
    firstWord: "",
    restTitle: "",
    images: [],
  };

  fetchProductDetails(id) {
    if (id) {
      console.log("Project ID:", id);

      axios
        .post("https://cheranmachines.com/api/product_detail.php", {
          id,
        })
        .then((response) => {
          const productDetails = response.data.responseJson[0];
          const table_head = productDetails.table_head || [];
          const table_body = productDetails.table_body || [];
          const features = productDetails.features.map((f) => f.feature) || [];
          const images = productDetails.icons || [];

          const [firstWord, ...rest] =
            productDetails.product_title_name.split(" ");
          const restTitle = rest.join(" ");
          const data2 = { table_head, table_body };
          this.setState({
            productDetails,
            data2,
            features,
            firstWord,
            restTitle,
            images,
          });
          console.log("data table", data2);
        })
        .catch((error) => {
          console.error("Error fetching product details:", error);
        });
    } else {
      console.error("No project ID found in URL params.");
    }
  }

  componentDidMount() {
    const { id } = this.props.params;
    this.fetchProductDetails(id);
  }

  componentDidUpdate(prevProps) {
    const { id } = this.props.params;
    if (id !== prevProps.params.id) {
      this.fetchProductDetails(id);
    }
  }

  shareOnWhatsApp = (title, message, link) => {
    const combinedMessage = `${title}: ${message}\n${link}`;
    const encodedMessage = encodeURIComponent(combinedMessage);

    window.open(`https://wa.me/?text=${encodedMessage}`);
  };

  render() {
    const options = {
      loop: true,
      autoplay: true,
      autoplayTimeout: 3000,
      margin: 30,
      nav: false,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      items: 1,
      dots: true,
    };
const { productDetails } = this.state;

const productId = this.props.params.id;

const seoData = productSeo[productId];

// Fallback-safe SEO
const seoTitle =
  seoData?.title ||
  `${productDetails.product_title_name || "Product"} | Cheran Machines`;

const seoDescription =
  seoData?.description ||
  `${productDetails.product_title_name || "Product"} manufactured by Cheran Machines for industrial applications.`;

const seoKeywords =
  seoData?.keywords ||
  `${productDetails.product_title_name || "Product"}, Cheran Machines, industrial machinery`;

const canonicalUrl =
  `${window.location.origin}${this.props.location.pathname}`;


    return (
      <>
      <Helmet>
  <title>{seoTitle}</title>

  <meta name="description" content={seoDescription} />
  <meta name="keywords" content={seoKeywords} />

  <link rel="canonical" href={canonicalUrl} />
</Helmet>

        <Header />
        <div className="page-content">
          <div
            className="text-uppercase"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "xxx-large",
              lineHeight: "normal",
            }}
          >
            <h3 className="font-weight-900 media-title">
              <span className="font-weight-900 " style={{ color: "#9e1975" }}>
                {this.state.firstWord}{" "}
              </span>{" "}
              {this.state.restTitle}
            </h3>
            <a
              className="mfp-link1"
              type="button"
              data-toggle="modal"
              data-target="#Default-Modal"
              style={{
                marginLeft: "10px", // Adjust the margin as needed
                cursor: "pointer",
                fontSize: "2rem",
                marginTop: "15px",
                paddingRight: "20px",
              }}
            >
              <i className="fa fa-share-alt" />
            </a>
          </div>
          <div className="section-full p-t30  bg-white  desk-pad">
            <div className="container">
              <div className="section-content">
                <div className="">
                  <div className="col-md-7 col-sm-6">
                    <div className="video-part-2">
                      <h3
                        className="font-weight-900 m-b20 text-uppercase"
                        style={{ color: "#9E1975", fontSize: "30px" }}
                      >
                        Features :
                      </h3>

                      <ul
                        className="list-arrow "
                        style={{ paddingLeft: "25px" }}
                      >
                        {this.state.features.map((feature, index) => (
                          <li key={index} style={{ fontSize: "16px" }}>
                            {feature}
                          </li>
                        ))}
                      </ul>
                      <ul className="icon-text-row">
                        {this.state.images.map((image, index) => (
                          <li className="icon-text-item" key={index}>
                            <div className="mt-icon-box-wraper center m-b30">
                              <div className="scale-in-center bg-moving">
                                <span className="icon-cell text-secondry">
                                  <img
                                    src={image.icon}
                                    style={{
                                      width: "75px",
                                      height: "75px",
                                      borderRadius: "10px",
                                    }}
                                  />
                                </span>
                                <p
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                    lineHeight: "normal",
                                    fontSize: "10px",
                                    paddingTop: "10px",
                                  }}
                                >
                                  {image.feature}
                                </p>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-5 col-sm-12">
                    <div className="service-about-left">
                      <div className="mt-media">
                        <img
                          src={this.state.productDetails.product_img}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section-full p-b40 bg-white inner-page-padding">
            <div className="container">
              <div className="section-content">
                <div
                  className="row "
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="col-lg-7  col-md-7 ">
                    <div className="section-head">
                      <div
                        className="mt-separator-outer separator-center"
                        style={{ marginBottom: "0px" }}
                      >
                        <div className="mt-separator pro-tab ">
                          <h2 className="text-black text-uppercase sep-line-one mob-tit">
                            <span className="font-weight-900 text-primary">
                              Technical{" "}
                            </span>{" "}
                            Specification
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <Table data={this.state.data2} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SimilarProjects />

        <div className="modal fade" id="myModal" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <ReactPlayer
                  url="https://youtu.be/TVnAcEkiEwM?feature=shared"
                  controls
                  width="100%"
                />
              </div>
            </div>
          </div>
        </div>

        <div id="Default-Modal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            {/* MODAL CONTENT*/}
            <div className="modal-content">
              <div
                className="modal-header bg-secondry"
                style={{ backgroundColor: "#9e1975" }}
              >
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
                <h4 className="modal-title" style={{ color: "#fff" }}>
                  SHARE
                </h4>
              </div>
              <div className="modal-body">
                <div
                  className="row"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FacebookShareButton
                    url={window.location.href}
                    quote={this.state.productDetails.product_title_name}
                    hashtag="#Share"
                    className="Demo__some-network__share-button"
                  >
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                  <TwitterShareButton
                    url={window.location.href}
                    title={this.state.productDetails.product_title_name}
                    hashtag="#Share"
                    className="Demo__some-network__share-button"
                  >
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                  <WhatsappShareButton
                    url={window.location.href}
                    title={this.state.productDetails.product_title_name}
                    separator=":: "
                    className="Demo__some-network__share-button"
                  >
                    <WhatsappIcon size={32} round />
                  </WhatsappShareButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default withRouter(ProjectDetail);
